import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import filter, { resolveFilterLabelsToIds } from '../../versa/filter.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import { flatten, deepen } from '../../versa/record.js';
import pdf from '../../versa/pdf.js';
import view from '../views/input-orders.js';
import form from '../forms/input-orders.js';
import upload_form from '../forms/input-orders-upload.js';
import order_upload_result_view from '../views/order-upload-result.js';
import formset from '../../versa/formset.js';
import * as types from '../types.js';

const inputOrders = function()
{

	let input_orders_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_programs, this.queryAll()).then((data) => db.set('programs', data).catch(() => {}));
			api.call(api.list_suppliers, this.queryAll()).then((data) => db.set('suppliers', data).catch(error => notify(error)));
			api.call(api.list_customers, this.queryAll()).then((data) => db.set('customers', data).catch(() => {}));
			api.call(api.list_carriers, this.queryAll()).then((data) => db.set('carriers', data).catch(error => notify(error)));
			api.call(api.list_products, this.queryAll()).then((data) => db.set('products', data).catch(error => notify(error)));
			api.call(api.list_units, this.queryAll()).then((data) => db.set('units', data).catch(error => notify(error)));
			api.call(api.list_users, this.queryAll()).then((data) => db.set('users', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_input_orders, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_input_order, ...JSON.parse(id));
			return flatten(_record, 'items');
		},
		async saveRecord(data, old_data)
		{
			data = deepen(data, 'items');
			const isReturn = data.is_return == '1';
			let _record = {
				reference: data.reference,
				supplier_id: isReturn ? null : Number(data.supplier_id),
				customer_id: isReturn ? Number(data.customer_id) : null,
				carrier_id: Number(data.carrier_id),
				program_id: data.program_id != null && data.program_id !== '' ? Number(data.program_id) : null,
				freight_type: data.freight_type,
				freight_value: Number(data.freight_value),
				discount: Number(data.discount),
				notes: data.notes?.trim(),
				is_return: isReturn,
				status: Number(data.status),
				items: (data.items || [])
				.filter(item => item && (item.product_id != null && item.product_id !== '') && Number(item.product_id) > 0)
				.map(item => ({ 
					product_id: Number(item.product_id),
					unit_id: Number(item.unit_id),
					quantity: Number(item.quantity),
					unit_price: Number(item.unit_price) 
				}))
			};
			if (old_data)
				return await api.call(api.update_input_order, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_input_order, data.company_id, _record);
		},
		editFilter() {
			filter.edit(this.applyFilter.bind(this), this.filter);
		},
		async applyFilter(data) {
			this.filter = await resolveFilterLabelsToIds(data, this.fieldspecs);
			this.loadPage(1);
		},
		uploadFromSpreadsheet()
		{
			const showResult = (result) =>
			{
				notify(order_upload_result_view(result, 'input'), 'Resultado do upload');
				this.loadPage();
				fs.destroy();
			};
			const sendRequest = async (data) =>
			{
				const formNode = document.querySelector(upload_form.form.selector);
				const fileInput = formNode?.querySelector('#file');
				const file = fileInput?.files?.[0];
				if (!file)
				{
					notify('Selecione um arquivo CSV ou XLSX.');
					return;
				}
				const company_id = data.company_id;
				if (!company_id)
				{
					notify('Selecione a empresa.');
					return;
				}
				const fd = new FormData();
				fd.append('file', file);
				fd.append('supplier_id', data.supplier_id);
				fd.append('program_id', data.program_id || '');
				const result = await api.call(api.upload_input_order, company_id, fd);
				if (result)
					showResult(result);
			};
			const setupTemplateLink = (fs) =>
			{
				const link = fs.dialog.getNode().querySelector('#download-template');
				if (link)
				{
					link.onclick = async (e) =>
					{
						e.preventDefault();
						const company_id = fs.form.getValues().company_id;
						if (!company_id)
						{
							notify('Selecione a empresa para baixar o modelo.');
							return;
						}
						const csv = await api.call(api.order_upload_template, company_id);
						if (csv && typeof csv === 'string')
						{
							const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
							const a = document.createElement('a');
							a.href = URL.createObjectURL(blob);
							a.download = 'modelo_pedido_upload.csv';
							a.click();
							URL.revokeObjectURL(a.href);
						}
					};
				}
			};
			const fs = formset.create(upload_form, sendRequest);
			fs.init = (() =>
			{
				Object.getPrototypeOf(fs).init.call(fs);
				setupTemplateLink(fs);
			})();
		},
		printOrderDocument()
		{
			const showResult = async (resp) =>
			{
				this.clearGridSelection();
				if (resp?.pdf)
					pdf(resp.pdf);
			}
			const sendRequest = async () =>
			{
				let ids = await this.getSelectedIds(['company_id', 'id']);
				let resp = await api.call(api.print_input_order_document, { 'ids': ids }).then(showResult);
			}
			ask(`Gerar documento de ${this.getCount()} pedido(s)?`, 'Documento de Pedido de Entrada', (answer) =>
			{
				if (answer == 'Y')
					sendRequest();
			});
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Pedido', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do pedido' },
		{ index: 3, field: 'reference', label: 'Referência', types: [], placeholder: '', title: 'Código de referência externa do pedido' },
		{ index: 4, field: 'created_on', label: 'Data Criação', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora de criação do pedido' },
		{ index: 5, field: 'created_by', label: 'Criado Por', types: [types.datalist()], placeholder: '', title: 'Usuário criador do pedido', store: 'users', labels: ['name'] },
		{ index: 6, field: 'updated_on', label: 'Data Alteração', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora da última atualização do pedido' },
		{ index: 7, field: 'updated_by', label: 'Alterado Por', types: [types.datalist()], placeholder: '', title: 'Último usuário a atualizar o pedido', store: 'users', labels: ['name'] },
		{ index: 8, field: 'supplier_id', label: 'Fornecedor', types: [types.datalist()], placeholder: '', title: 'Fornecedor', store: 'suppliers', labels: ['nick'] },
		{ index: 9, field: 'carrier_id', label: 'Transportador', types: [types.datalist()], placeholder: '', title: 'Transportador', store: 'carriers', labels: ['nick'] },
		{ index: 10, field: 'program_id', label: 'Programa', types: [types.datalist()], placeholder: '', title: 'Programa sugerido para a entrada', store: 'programs', labels: ['name'] },
		{ index: 11, field: 'freight_type', label: 'Tipo Frete', types: [types.opt_freight_type(), types.datalist()], placeholder: '', title: 'Tipo de frete' },
		{ index: 12, field: 'freight_value', label: 'Valor Frete', types: [types.number(2)], placeholder: '0,00', title: 'Valor do frete' },
		{ index: 13, field: 'discount', label: '% Desconto', types: [types.number(2)], placeholder: '0,00', title: 'Percentual de desconto' },
		{ index: 14, field: 'value', label: 'Valor', types: [types.number(2)], placeholder: '0,00', title: 'Valor do pedido' },
		{ index: 15, field: 'notes', label: 'Observações', types: [], placeholder: '', title: 'Observações do pedido' },
		{ index: 16, field: 'is_return', label: 'Devolução', types: [types.opt_bool(), types.datalist()], placeholder: '', title: 'Indicador de devolução' },
		{ index: 17, field: 'status', label: 'Status', types: [types.opt_input_order_status(), types.datalist()], placeholder: '', title: 'Status do pedido' },
	];

	let operations = [
		{ hash: '#upload', label: 'Upload&nbsp;planilha' },
	];

	let reports = [
		{ hash: '#print-order-doc', label: 'Documento&nbsp;do&nbsp;Pedido' },
	];

	router.set('#upload', input_orders_crud.uploadFromSpreadsheet.bind(input_orders_crud));
	router.set('#print-order-doc', input_orders_crud.printOrderDocument.bind(input_orders_crud));

	input_orders_crud.run(
		'input_orders',
		'Pedidos&nbsp;Entrada',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		reports
	);

};

export default inputOrders;

